<template lang="pug"> 
  v-select(
    v-model='selectItem'
    outlined
    dense
    hide-details="auto"
    item-text='name'
    item-value='id'
    :label="label"
    require 
    :items='items'
    :rules="rules"
    :disabled="disabled"
  )
</template>

<script>
import { anonymous as apiAnonymous } from '@/apis' 
export default {

  props : {
    value:{
      type: Number,
      default: null
    }, 
    rules:{
      type:Array,
      default: () => []
    },
    label: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({ 
    selectItem :null,
    items : []
  }), 

  watch: {
    selectItem (val) {
      this.$emit('input',val)
    }
  },

  async mounted () {
    this.selectItem = this.value
    await this.load ()
  }, 

  methods : {  
    async load () {
      const [err,data] = await apiAnonymous.getBankTypeList()
      if(err){
        return
      }
      this.items = data
      this.selectItem = this.value
    }, 
  }
}
</script>